import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogActions from "@mui/material/DialogActions";
import { useHistory } from 'react-router-dom';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const SuccessfullPopup = (props) => {
  const { open, setOpen } = props;
  const history = useHistory();
  const handleClose = () => {
    setOpen(false);
    history.push('/notification');

  };

  return (
    <div className="popup-wrap">
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="sm"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Successful Confirmation
        </BootstrapDialogTitle>

        <DialogContent dividers>
          <div className="popup-body">
            <div className="popup-content">
              <h2 className="popup-sub-title">Successful!</h2>
              <p className="popup-description">
                Your notification has been sent successfully
              </p>
            </div>
          </div>
        </DialogContent>
        <div className="dialog-btn-wrap">
          <DialogActions>
            <Button variant="contained" onClick={handleClose}>
              Ok
            </Button>
          </DialogActions>
        </div>
      </BootstrapDialog>
    </div>
  );
};

export default SuccessfullPopup;
